import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const TestPageWrapper = styled.div`
  .banner-image-wrapper {
    /* inline-block .ant-image leaves a baseline gap below the image otherwise */
    line-height: 0;
  }

  .banner-image-wrapper img {
    height: auto;
    width: 100%;
    object-fit: cover;
    display: block;
  }

  .popular-products {
    padding: 32px 0 60px 0;
  }

  .popular-categories {
    padding-bottom: 21px;
  }

  .popular-products h1,
  .popular-categories h1 {
    font-family: ${(props) => props.theme.fontText};
    font-size: 42px;
    font-weight: 500;
    line-height: 38px;
  }

  .popular-categories .title {
    padding-bottom: 0;
  }

  .popular-categories h1 {
    margin-bottom: 54px;
  }

  .banner-image-wrapper {
    width: 100%;
    padding: 50px 0 30px 0;
    margin: 0 auto;
  }

  .banner_1 {
    padding: 0;
    .ant-image-img {
      height: 280px;
    }
  }

  .home-banner-wrapper {
    position: relative;

    .ant-image::after {
      content: '';
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.35);
      z-index: 10;
      pointer-events: none;
    }
  }

  .buy-latvia-food-desktop {
    position: absolute;
    inset: 0;
    z-index: 11;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${(props) => props.theme.white};
    pointer-events: none;
    padding-top: 10px;

    .title-section {
      max-width: 443px;

      h3 {
        margin: 0;
        font-family: ${(props) => props.theme.fontText};
        font-weight: 400;
        font-size: 52px;
        line-height: 1.05;
      }
    }

    .counter-section {
      max-width: 182px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 6px;

      h3 {
        margin: 0;
        font-family: ${(props) => props.theme.fontText};
        font-weight: 400;
        font-size: 16px;
        text-align: right;

        b {
          font-size: 48px;
          font-weight: 500;
          line-height: 1;
        }
      }
    }
  }

  .home-banner-search {
    margin-top: -80px;
    position: relative;
    z-index: 12;
    padding: 0;

    .input-container,
    .ant-form,
    .ant-form-item,
    .ant-form-item-control,
    .ant-form-item-control-input,
    .ant-form-item-control-input-content {
      width: 100%;
    }

    .ant-input-affix-wrapper,
    .ant-input-affix-wrapper-lg {
      height: 45px !important;
      border-radius: 30px !important;
      background-color: ${(props) => props.theme.white} !important;
      border: 1px solid ${(props) => props.theme.menuBorderBottom} !important;
      padding: 0 12px !important;
      align-items: center;

      .ant-input {
        &::placeholder {
          color: ${(props) => props.theme.black};
          opacity: 1;
        }
      }
    }

    .ant-input-prefix {
      margin-right: 7px !important;
    }

    .ant-input {
      font-size: 11px !important;
      &::placeholder {
        color: ${(props) => props.theme.black};
      }
    }
  }

  .home-banner-print {
    display: flex;
    width: 100%;
    height: 85px;
    overflow: hidden;
    margin-top: -47px;
    position: absolute;
    z-index: 1;
    background-image: url('/svgs/landing-page-watermark.svg');
    background-size: auto;
    background-repeat: repeat-x;

    .landing-page-watermark {
      height: 85px;
    }
  }

  .banner_2 {
    .ant-image-img {
      height: 450px;
    }
  }

  .banner_3 {
    .ant-image-img {
      height: 450px;
    }
  }

  .banner_4 {
    .ant-image-img {
      height: 450px;
    }
  }

  .desktop-banner {
    .slick-dots-bottom {
      bottom: 26px;
    }
  }

  .slick-slider {
    margin-bottom: 0;
  }

  .banner-wrapper.banner_3 {
    padding: 0;
  }

  .banners {
    padding-top: 100px;
    padding-bottom: 60px;
    .container > div {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .banner-wrapper,
    .banner-image-wrapper {
      padding: 0;
    }

    .slick-slider .slick-dots-bottom {
      bottom: -32px;
    }
  }

  .discount-items {
    background-color: ${(props) => props.theme.brightGrey};

    .banner-wrapper .slick-dots-bottom {
      bottom: -20px;
    }

    .row .slick-dots {
      padding-bottom: 26px;
    }
  }

  .discount-items .slick-slide {
    justify-content: space-between;
  }

  .discount-items .slick-dots .slick-active {
    width: 64px !important;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .popular-products {
      background-color: ${({ theme }) => theme.brightGrey};

      .title h1 {
        font-size: 1.125rem !important;
      }
    }

    .popular-categories {
      .title h1 {
        font-size: 1.125rem !important;
        margin-bottom: 20px;
      }
    }

    .banner-wrapper.banner_1 {
      display: none;
    }

    .home-banner-search {
      display: none;
    }

    .buy-latvia-food-desktop {
      display: none;
    }

    .home-banner-print {
      display: none;
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .popular-products {
      padding: 0 0 48px 0;

      .title h1 {
        font-size: 18px;
        font-weight: 600;
        margin-top: 0;
      }
    }

    .discount-items {
      padding-top: 20px;

      .slick-dots-bottom {
        bottom: 0;
        padding-bottom: 20px !important;
      }
    }

    .banners {
      background-color: ${(props) => props.theme.brightGrey};
      padding-bottom: 0;
      padding-top: 0;

      .banner-image-wrapper {
        padding-top: 0;
      }

      .banner-wrapper {
        padding-top: 0;
        padding-bottom: 21px;
      }

      .slick-dots {
        display: none !important;
      }
    }

    .mobile-product-category {
      padding: 20px 0 44px 0;

      .title {
        padding: 0 20px;

        h1 {
          margin-top: 0;
        }
      }
    }
  }
`;
